export enum RoleTypes {
    "SuperUser" = "S",
    "Internal" = "I",
    "External" = "E"
}